import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material';
import DataTable from 'components/Common/DataTable';
import Pagination from 'components/Common/Pagination';
import { Signal } from '@/apis/business/agent/signals/types';
import { getSignalsColumns } from './signalsColumns';
import { SignalsListingSkeleton } from './SignalsSkeletons';

interface SignalsListingProps {
  data: Signal[];
  isLoading: boolean;
  currentPage: number;
  totalPages: number;
  totalCount: number;
  perPage: number;
  onPageChange: (value: number) => void;
  onPerPageChange: (perPage: number) => void;
}

export default function SignalsListing({
  data,
  isLoading,
  currentPage,
  totalPages,
  totalCount,
  perPage,
  onPageChange,
  onPerPageChange
}: SignalsListingProps) {
  const theme = useTheme();
  const { search } = useLocation();

  if (isLoading) {
    return <SignalsListingSkeleton />;
  }

  return (
    <>
      <DataTable data={data} columns={getSignalsColumns(theme, search)} isHeaderSticky={true} isLoading={false} />
      <Pagination
        totalPages={totalPages}
        totalCount={totalCount}
        currentPage={currentPage}
        perPage={perPage}
        onChange={onPageChange}
        onPerPageChange={onPerPageChange}
      />
    </>
  );
}
